export enum AlreadyHaveActiveApplicationType {
  Borrower = 'Borrower',
  BorrowerAsCoBorrower = 'BorrowerAsCoBorrower',
  CoBorrower = 'CoBorrower',
}
